// Validates HH:MM format using regex
const validateTimeFormat = (input) => {
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  return timeRegex.test(input);
};

function findOverlappingPeriods(periods) {
  const overlappingPeriods = [];
  const seenOverlaps = new Set(); // To avoid duplicates

  // Helper function to check if two periods overlap
  function periodsOverlap(period1, period2) {
    const start1 = new Date(period1.startDate);
    const end1 = new Date(period1.endDate);
    const start2 = new Date(period2.startDate);
    const end2 = new Date(period2.endDate);

    // Check for overlap
    // Period 1 starts before Period 2 ends AND Period 2 starts before Period 1 ends
    return start1 <= end2 && start2 <= end1;
  }

  // Compare each period with every other period
  for (let i = 0; i < periods.length; i++) {
    for (let j = i + 1; j < periods.length; j++) {
      if (periodsOverlap(periods[i], periods[j])) {
        const badPeriods = [periods[i].name, periods[j].name].sort();
        // Create a unique key for this pair to avoid duplicates
        const pairKey = badPeriods.join('-');

        if (!seenOverlaps.has(pairKey)) {
          overlappingPeriods.push(badPeriods);
          seenOverlaps.add(pairKey);
        }
      }
    }
  }

  // Return unique period names that have overlaps
  return [...new Set(overlappingPeriods)];
}

function generateTimeSlots() {
  const timeSlots = [];
  const startHour = 6; // 6:00 AM
  const endHour = 20; // 8:00 PM

  for (let hour = startHour; hour <= endHour; hour++) {
    // Format hour to ensure two digits (e.g., '06' instead of '6')
    const formattedHour = hour.toString().padStart(2, '0');

    timeSlots.push({
      label: `${formattedHour}:00`,
      value: `${formattedHour}:00`,
    });

    if (hour < endHour) {
      timeSlots.push({
        label: `${formattedHour}:30`,
        value: `${formattedHour}:30`,
      });
    }
  }

  return timeSlots;
}

export { findOverlappingPeriods, validateTimeFormat, generateTimeSlots };
